var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.currentComponent,{tag:"component",on:{"newView":_vm.newViewHandler}})
}
var staticRenderFns = []

export { render, staticRenderFns }